import React from 'react';

import { Tooltip } from 'components/ClubComponents';
import { ReactComponent as BadgeDollar } from 'components/svg/icons/badge-dollar.svg';
import { ReactComponent as FileAlt } from 'components/svg/icons/file-alt.svg';
import { ReactComponent as QuestionSquare } from 'components/svg/icons/question-square.svg';
import { ReactComponent as SignalStream } from 'components/svg/icons/signal-stream.svg';
import { WEBINAR_LIVE } from 'modules/membership/constants';

export const TYPES = {
  ADVERTISEMENT: {
    label: 'upsell',
    icon: <BadgeDollar data-test="page-type-icon" />
  },
  CONTENT: {
    label: 'content',
    icon: <FileAlt data-test="page-type-icon" />
  },
  QUIZ: {
    label: 'quiz',
    icon: <QuestionSquare data-test="page-type-icon" />
  },
  WEBINAR: {
    label: 'webinar',
    icon: <SignalStream data-test="page-type-icon" />
  }
};

export const CHANGEABLE_PAGE_ITEM_PROPS = ['name', 'published', 'totalPages'];

export const ICON_SIZE = 16;

export const CONDITIONS = [{ configs: [WEBINAR_LIVE] }];
export const DRIPPING_ICONS_SIZE = 16;

export const TOOLTIP_PROPS = {
  alignment: Tooltip.ALIGNMENT.CENTER,
  position: Tooltip.POSITION.TOP,
  mode: Tooltip.MODE.LIGHT
};
